import { render, staticRenderFns } from "./client-share.vue?vue&type=template&id=6d31c534&scoped=true"
import script from "./client-share.vue?vue&type=script&lang=js"
export * from "./client-share.vue?vue&type=script&lang=js"
import style0 from "./client-share.vue?vue&type=style&index=0&id=6d31c534&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d31c534",
  null
  
)

export default component.exports